export enum EnergyMode {
  FPM = 'FPM',
  ECO1 = 'ECO1',
  ECO2 = 'ECO2',
  PSM = 'PSM'
}
